module.exports = __webpack_public_path__ + "img/97ne.f81ac6d5.svg";